/** Textes « caisseExtra » — le français fait foi. */
export const caisseExtra = {
  modes: {
    especes: 'Espèces', cheque: 'Chèque', virement: 'Virement', carte: 'Carte', traite: 'Traite',
  } as Record<string, string>,
  erreurChargement: 'La caisse extra n\'a pas pu être chargée.',
  ligneEnregistree: 'Ligne enregistrée.',
  enregistrementImpossible: 'Enregistrement impossible',
  videe: 'Caisse extra vidée.',
  transfertImpossible: 'Transfert impossible',
  erreurTitre: 'La caisse extra ne s\'affiche pas',
  titre: 'Caisse extra',
  sousTitre: 'Une caisse libre : vos mots, vos montants. Videz-la quand vous voulez.',
  ajouterLigne: 'Ajouter une ligne',
  vider: 'Vider la caisse extra',
  kpi: {
    dedans: 'Ce qu\'il y a dedans', devises: 'Devises', vide: 'vide',
    lignes: 'Lignes', lignesDetail: 'les 400 dernières',
  },
  historique: 'Ce qui est passé par là',
  videTitre: 'La caisse extra est vide',
  videTexte: 'Elle sert à ce qui n\'entre dans aucune autre case : un dépôt, une recette annexe, une avance à régulariser. Le libellé est le vôtre.',
  colonnes: { date: 'Date', libelle: 'Libellé', nature: 'Nature', payeEn: 'Payé en', par: 'Par', montant: 'Montant' },
  saisie: {
    entre: 'De l\'argent entre', sort: 'De l\'argent sort',
    libelle: 'Libellé', libelleAide: 'Vos mots. C\'est ce que vous relirez dans six mois.',
    libelleExemple: 'Dépôt de l\'associé, recette annexe…',
    montant: 'Montant', devise: 'Devise', payeEn: 'Payé en',
  },
  vidage: {
    ilYA: 'Il y a ',
    enDevise: (devise: string) => ` en ${devise} dans la caisse extra.`,
    versCaisse: 'Vers la caisse', versBanque: 'Vers la banque', ailleurs: 'Ailleurs',
    ouVa: 'Où va cet argent ?', libelle: 'Libellé',
    ouVaAide: 'Obligatoire : une sortie sans motif ne se retrouve plus.', facultatif: 'Facultatif.',
    ouVaErreur: 'Dites où va cet argent.',
    exempleDehors: 'Remis au gérant, versé au fournisseur…',
    exempleLibelle: 'Caisse extra vidée',
    titreDehors: 'L\'argent quitte l\'agence',
    titrePoche: 'L\'argent change de poche',
    texteDehors: 'Cette somme sortira des comptes de l\'agence. Elle ne réapparaîtra ni en caisse ni en banque : seul le motif dira ce qu\'elle est devenue.',
    textePoche: (versBanque: boolean) => `Deux lignes liées seront écrites : une sortie de la caisse extra, une entrée dans ${versBanque ? 'la banque' : 'la caisse'}. Le total de l'agence ne bouge pas.`,
    bouton: 'Vider',
  },
};
